export default "__VITE_ASSET__WFB9wc56__"